module.exports = __webpack_public_path__ + "static/Antonin_Leuret-4fe4288b0a50d02e0e0c24681ffb34c5.webp";